import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Cars.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useEffect } from 'react';

function Cars() {
  const [make, setMake] = useState('');
  const [model, setModel] = useState('');
  const [makes, setMakes] = useState([]);
  const [models, setModels] = useState([]);
  const navigate = useNavigate();
  const [showAllBrands, setShowAllBrands] = useState(false); // already there

  useEffect(() => {
    const fetchMakes = async () => {
      try {
        const res = await axios.get('/api/vehicles/distinct/car');
        setMakes(res.data.make.sort());
      } catch (err) {
        console.error('Error fetching makes:', err);
      }
    };
    fetchMakes();
  }, []);

  useEffect(() => {
    const fetchModels = async () => {
      if (!make) {
        setModels([]);
        setModel('');
        return;
      }
      try {
        const res = await axios.get(`/api/vehicles/distinct/car?make=${encodeURIComponent(make)}`);
        setModels(res.data.model.sort());
      } catch (err) {
        console.error('Error fetching models:', err);
      }
    };
    fetchModels();
  }, [make]);

  const handleMakeChange = (e) => setMake(e.target.value);
  const handleModelChange = (e) => setModel(e.target.value);

  const handleSearch = (e) => {
    e.preventDefault();
    const query = [`make=${encodeURIComponent(make)}`, model && `model=${encodeURIComponent(model)}`]
      .filter(Boolean)
      .join('&');
    navigate(`/car-search?${query}`);
  };

  const toggleShowBrands = () => setShowAllBrands(!showAllBrands);

  return (
    <div className="cars-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h2>Car finance</h2>
          <p>See cars available on finance near you</p>
          <form className="car-search-form" onSubmit={handleSearch}>
            <select name="make" value={make} onChange={handleMakeChange}>
              <option value="">Make</option>
              {makes.map((m) => (
                <option key={m} value={m}>{m}</option>
              ))}
            </select>
            <select name="model" value={model} onChange={handleModelChange} disabled={!make}>
              <option value="">Model</option>
              {models.map((mo) => (
                <option key={mo} value={mo}>{mo}</option>
              ))}
            </select>
            <button type="submit" className="cta-button">Search Cars</button>
          </form>
          <p className="learn-more">
            <Link to="/finance-info">How much can I afford?</Link>
          </p>
        </div>
      </section>

      {/* Popular Brands Section */}
      <section className="brands">
        <h2>View finance deals from popular brands</h2>
        <div className="brand-grid">
          <Link to="/car-search?make=Ford" className="brand-logo">
            <img src={require('../assets/logos/ford-logo.jpg')} alt="Ford Logo" />
            <span>Ford</span>
          </Link>
          <Link to="/car-search?make=Volkswagen" className="brand-logo">
            <img src={require('../assets/logos/volkswagen-logo.jpg')} alt="Volkswagen Logo" />
            <span>Volkswagen</span>
          </Link>
          <Link to="/car-search?make=Audi" className="brand-logo">
            <img src={require('../assets/logos/audi-logo.jpg')} alt="Audi Logo" />
            <span>Audi</span>
          </Link>
          <Link to="/car-search?make=Mercedes-Benz" className="brand-logo">
            <img src={require('../assets/logos/mercedes-logo.jpg')} alt="Mercedes-Benz Logo" />
            <span>Mercedes-Benz</span>
          </Link>
          {showAllBrands && (
            <>
              {/* Additional brands */}
              <Link to="/car-search?make=BMW" className="brand-logo">
                <img src={require('../assets/logos/bmw-logo.jpg')} alt="BMW Logo" />
                <span>BMW</span>
              </Link>
              <Link to="/car-search?make=Peugeot" className="brand-logo">
                <img src={require('../assets/logos/peugeot-logo.jpg')} alt="Peugeot Logo" />
                <span>Peugeot</span>
              </Link>
              <Link to="/car-search?make=Nissan" className="brand-logo">
                <img src={require('../assets/logos/nissan-logo.jpg')} alt="Nissan Logo" />
                <span>Nissan</span>
              </Link>
              <Link to="/car-search?make=Renault" className="brand-logo">
                <img src={require('../assets/logos/renault-logo.jpg')} alt="Renault Logo" />
                <span>Renault</span>
              </Link>
              <Link to="/car-search?make=Honda" className="brand-logo">
                <img src={require('../assets/logos/honda-logo.jpg')} alt="Honda Logo" />
                <span>Honda</span>
              </Link>
              <Link to="/car-search?make=Kia" className="brand-logo">
                <img src={require('../assets/logos/kia-logo.jpg')} alt="Kia Logo" />
                <span>Kia</span>
              </Link>
              <Link to="/car-search?make=Toyota" className="brand-logo">
                <img src={require('../assets/logos/toyota-logo.jpg')} alt="Toyota Logo" />
                <span>Toyota</span>
              </Link>
            </>
          )}
        </div>
        <button onClick={toggleShowBrands} className="view-all-brands-btn">
          {showAllBrands ? 'Hide all brands' : 'Show all brands'}
        </button>
      </section>

      {/* How Finance Works Section */}
      <section className="finance-info">
        <h2>How finance works on Vanir Motor Group</h2>
        <p>
          Simply input your location to see vehicles available on finance or explore our various finance options.
        </p>
        <p>
          We offer a broad selection of vehicles with various finance options tailored to suit your needs.
        </p>
        <Link to="/finance-options" className="cta-button">Learn more about financing</Link>
      </section>

      {/* Monthly Prices Section */}
      <section className="monthly-prices">
        <div className="info-box">
          <h3>See monthly prices upfront</h3>
          <p>
            You can find vehicles on PCP, HP, or CS finance based on your preferences.
          </p>
          <Link to="/finance-prices" className="cta-button">Learn more</Link>
        </div>
      </section>

      {/* Footer Guides Section */}
      <section className="guides">
        <h2>Car finance guides</h2>
        <div className="guides-grid">
          <div className="guide-card">Tips on applying for car finance</div>
          <div className="guide-card">What to do if you have a poor credit score</div>
          <div className="guide-card">Which type of finance is right for you</div>
          <div className="guide-card">Buying a car on finance</div>
        </div>
      </section>
    </div>
  );
}

export default Cars;
